"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _uuid = require("uuid");

var _ramda = require("ramda");

var _constants = require("./constants");

var _getSession2 = _interopRequireDefault(require("./getSession"));

var _setSession = _interopRequireDefault(require("./setSession"));

var _extractQueryParams = _interopRequireDefault(require("../utils/extract-query-params"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var _default = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var sessionName, _ref$location, location, _ref$siteData, siteData, _ref$baseUrl, baseUrl, validSessionName, _getSession, sessionId, params, a, source, otherParams, adId, channel, referrer, userAgent, pageDetails, landingPage, productId, sessionData;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            sessionName = _ref.sessionName, _ref$location = _ref.location, location = _ref$location === void 0 ? {} : _ref$location, _ref$siteData = _ref.siteData, siteData = _ref$siteData === void 0 ? {} : _ref$siteData, _ref$baseUrl = _ref.baseUrl, baseUrl = _ref$baseUrl === void 0 ? '' : _ref$baseUrl;
            validSessionName = sessionName;

            if (!sessionName) {
              console.error("DEFAULTING TO \"".concat(_constants.DEFAULT_SESSION_NAME, "\" as no session name provided"));
              validSessionName = _constants.DEFAULT_SESSION_NAME;
            }

            _getSession = (0, _getSession2["default"])(validSessionName), sessionId = _getSession.sessionId; // Exit early if session is already set.

            if (!sessionId) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return");

          case 6:
            params = (0, _extractQueryParams["default"])((0, _ramda.propOr)('', 'search', location));
            a = params.a, source = params.source, otherParams = (0, _objectWithoutProperties2["default"])(params, ["a", "source"]);
            adId = (0, _ramda.propOr)(false, 'a', params);
            channel = (0, _ramda.propOr)(false, 'source', params);
            referrer = (0, _ramda.propOr)(false, 'referrer', document);
            userAgent = (0, _ramda.propOr)(false, 'userAgent', navigator);
            pageDetails = siteData.pageDetails;
            landingPage = {
              id: (0, _ramda.propOr)('', 'pageId', pageDetails),
              name: (0, _ramda.propOr)('', 'pageName', pageDetails),
              brand: (0, _ramda.propOr)('', 'brand', pageDetails),
              variant: (0, _ramda.propOr)('', 'pageVariant', pageDetails),
              url: "".concat((0, _ramda.propOr)('', 'origin', location)).concat((0, _ramda.propOr)('', 'pathname', location)),
              searchString: (0, _ramda.propOr)('', 'search', location),
              params: _objectSpread({}, otherParams)
            };
            productId = (0, _ramda.prop)('productId', pageDetails);
            sessionData = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
              sessionId: (0, _uuid.v4)(),
              productId: parseInt(productId, 10) || null,
              landingPage: landingPage
            }, referrer && {
              referrer: referrer
            }), userAgent && {
              userAgent: userAgent
            }), adId && {
              adId: adId
            }), channel && {
              channel: channel
            });
            (0, _setSession["default"])(validSessionName, sessionData);

            if (baseUrl) {
              _context.next = 19;
              break;
            }

            return _context.abrupt("return");

          case 19:
            _context.next = 21;
            return fetch("".concat(baseUrl, "/sessions/"), {
              body: JSON.stringify(sessionData),
              method: 'post'
            }).then(function (res) {
              return res.json();
            }) // eslint-disable-next-line no-console
            ["catch"](function (err) {
              return console.error(err.message);
            });

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports["default"] = _default;